export const WORKSPACE_PREFIXES = ['Website', 'Application'];

export const SITE_TYPES = [
  'E-Commerce (B2C)',
  'E-Commerce (B2B)',
  'Corporate Website',
  'Marketing Website',
  'Blog / Publication',
  'Documentation / Knowledge Base',
  'Customer Portal',
  'Partner Portal',
  'Community',
  'SaaS',
  'Other',
];

export function isMobileWorkspace(prefix) {
  return prefix === 'Application' || prefix === 'Mobile App';
}

/**
 * Field copy for workspace setup step 3.
 * Application collects an App name (not a URL) in the slug input — BWC-5011/5012.
 */
export function workspaceSetupLabels(prefix) {
  if (isMobileWorkspace(prefix)) {
    return {
      name: 'Workspace Name',
      type: 'Site Type',
      slugLabel: 'Your Application',
      slugHint: 'Name',
      slugPlaceholder: 'My App',
    };
  }
  return {
    name: 'Workspace Name',
    type: 'Site Type',
    slugLabel: 'Your Website',
    slugHint: 'URL',
    slugPlaceholder: 'https://example.com',
  };
}

export function canSubmitWorkspaceSetup({
  workspaceName,
  workspacePrefix,
  siteType,
  workspaceUrl,
  loading,
} = {}) {
  const name = String(workspaceName || '').trim();
  const slugValue = String(workspaceUrl || '').trim();
  if (!name || loading || !siteType) {
    return false;
  }
  // Website: URL required. Application: App name required (not a URL).
  return Boolean(slugValue);
}

/**
 * Explains why the workspace setup submit button is disabled.
 * @param {object} params
 * @returns {string | undefined}
 */
export function getWorkspaceSetupDisabledReason({
  workspaceName,
  workspacePrefix,
  siteType,
  workspaceUrl,
  loading,
} = {}) {
  if (loading) {
    return 'Creating your workspace…';
  }
  const name = String(workspaceName || '').trim();
  const slugValue = String(workspaceUrl || '').trim();
  const labels = workspaceSetupLabels(workspacePrefix);
  if (!name) {
    return 'Enter a workspace name';
  }
  if (!siteType) {
    return `Select a ${labels.type.toLowerCase()}`;
  }
  if (!slugValue) {
    return isMobileWorkspace(workspacePrefix)
      ? 'Enter your application name'
      : 'Enter your website URL';
  }
  return undefined;
}

export function workspaceSetupPayload({
  email,
  workspaceName,
  workspacePrefix,
  siteType,
  workspaceUrl,
} = {}) {
  const trimmedName = String(workspaceName || '').trim();
  const trimmedSlug = String(workspaceUrl || '').trim();
  return {
    email,
    workspaceName: trimmedName,
    workspacePrefix,
    siteType,
    // Application sends the App name in workspaceUrl; Website sends the URL.
    workspaceUrl: trimmedSlug,
  };
}
